<template>
  <div>
    <div
      class="mb-2"
      style="display: flex; justify-content: space-between; align-items: start;"
    >
      <h2>Incidents & Outages</h2>
    </div>
    <div>
      <div
        v-if="isLoadingIncidents"
        v-loading="isLoadingIncidents"
        style="height: 100px;"
      />
      <div v-if="!$_.isEmpty(incidents) && !isLoadingIncidents">
        <div
          v-for="incident in incidents"
          :key="incident.id"
        >
          <div
            class="background-job-container"
          >
            <div>
              <b class="mb-2">{{ $_.get(incident, 'name', '-') }}</b>
              <br>
              <p
                class="mb-2"
                style="word-break: break-word;"
              >
                {{ $_.get(incident, 'description', '-') }}
              </p>
              <br>
              <span class="text-muted">
                Type:
                <el-tag
                  type="info"
                  size="mini"
                >
                  {{ $_.get(incident, 'type.name', '-') }}
                </el-tag>
                &nbsp;
                Priority:
                <el-tag
                  :type="getPriorityTagType($_.get(incident, 'priority.name', '-'))"
                  size="mini"
                >
                  {{ $_.get(incident, 'priority.name', '-') }}
                </el-tag>
                &nbsp;
                Status:
                <el-tag
                  :type="getStatusTagType($_.get(incident, 'status.name', '-'))"
                  size="mini"
                >
                  {{ $_.get(incident, 'status.name', '-') }}
                </el-tag>&nbsp;
                <span style="float: right;">
                  {{ $moment(incident.created_at).fromNow() }}
                </span>
              </span>
            </div>
          </div>
        </div>
        <el-pagination
          v-if="incidents.length > 0"
          class="text-center pt-3"
          :current-page.sync="page"
          :page-size.sync="incidents.limit"
          layout="prev, pager, next"
          :total="incidents.total"
          @size-change="loadIncidents"
          @current-change="loadIncidents"
        />
      </div>
      <div
        v-else-if="!isLoadingIncidents && $_.isEmpty(incidents)"
        class="text-center p-4"
      >
        <FontAwesomeIcon
          :icon="['fal', 'microchip']"
          size="4x"
        />
        <br>
        <p>No incidents found</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      progress: 60,
      isLoadingIncidents: false,
      incidents: [],
      incidentsInterval: null,
      page: 1
    }
  },
  mounted () {
    this.loadIncidents()
    this.incidentsInterval = setInterval(() => {
      this.loadIncidents()
    }, 60000)
  },
  beforeDestroy () {
    clearInterval(this.incidentsInterval)
  },
  methods: {
    loadIncidents () {
      this.isLoadingIncidents = true
      this.$sdk.incident.list(builder => {
        builder.include = ['type', 'priority', 'status']
        builder.order = 'created_at:desc'
        builder.limit = 10
        builder.page = this.page
      })
        .then(res => {
          this.incidents = res
          const activeIncidents = res.filter(incident => {
            return incident.status.name === 'Open' || incident.status.name === 'Pending'
          })
          this.$emit('active-incidents', activeIncidents.length)
        })
        .finally(() => { this.isLoadingIncidents = false })
    },
    getPriorityTagType (status) {
      switch (status) {
        case 'High':
          return 'danger'
        case 'Low':
          return ''
        case 'Medium':
          return 'warning'
      }
      return 'danger'
    },
    getStatusTagType (status) {
      switch (status) {
        case 'Open':
          return 'danger'
        case 'Pending':
          return 'warning'
        case 'Closed':
          return 'success'
      }
      return 'danger'
    },
    getTagType (status) {
      switch (status) {
        case -2:
          return 'danger'
        case -1:
          return 'danger'
        case 0:
          return ''
        case 1:
          return 'warning'
        case 2:
          return 'success'
      }
      return 'danger'
    }
  }
}
</script>

<style lang="scss" scoped>
@import "variables";
.background-job-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 0px 7px 0px;
  border-bottom: 1px solid $light;
}
</style>
